import { OBJECTIVES, HINTS, PUZZLES } from '../config/gameConfig';

export type Flag =
  | 'saw_painting'
  | 'clock_done'
  | 'desk_opened'
  | 'paper_revealed'
  | 'shelf_done'
  | 'safe_opened'
  | 'piano_done'
  | 'cabinet_opened'
  | 'valves_done'
  | 'basement_unlocked'
  | 'pressure_ok'
  | 'fuse_installed'
  | 'power_restored'
  | 'hidden_unlocked'
  | 'lamp_lit'
  | 'mirrors_done'
  | 'escaped';

export type ShelfColor = 'red' | 'blue' | 'green' | 'yellow';

export class PuzzleState {
  private flags = new Set<Flag>();
  clockHour = 12;
  clockMinute = 0;
  /** 本棚の現在の並び（初期はシャッフル済み固定） */
  shelf: ShelfColor[] = ['yellow', 'red', 'green', 'blue'];
  pianoBuffer: string[] = [];
  valveSequence: string[] = [];
  /** 配線: 接続済みか */
  wires = [false, false, false];
  /** 配線を押した順序 */
  wireSequence: number[] = [];
  pressure = 0;
  mirrors = [0, 0, 0];
  onFlag: ((flag: Flag) => void) | null = null;

  has(flag: Flag): boolean {
    return this.flags.has(flag);
  }

  set(flag: Flag): void {
    if (this.flags.has(flag)) return;
    this.flags.add(flag);
    this.onFlag?.(flag);
  }

  private stageOrder: Flag[] = [
    'saw_painting',
    'clock_done',
    'desk_opened',
    'paper_revealed',
    'shelf_done',
    'safe_opened',
    'piano_done',
    'cabinet_opened',
    'valves_done',
    'pressure_ok',
    'power_restored',
    'lamp_lit',
    'mirrors_done',
  ];

  currentStageKey(): string {
    let key = 'start';
    for (const f of this.stageOrder) {
      if (this.has(f)) key = f;
    }
    return key;
  }

  getObjective(): string {
    const key = this.currentStageKey();
    return OBJECTIVES.find((o) => o.when === key)?.text ?? OBJECTIVES[0].text;
  }

  getHint(): string {
    const key = this.currentStageKey();
    return HINTS.find((h) => h.when === key)?.text ?? HINTS[0].text;
  }

  isShelfCorrect(): boolean {
    const target = PUZZLES.shelfOrder as unknown as string[];
    return this.shelf.every((c, i) => c === target[i]);
  }
}
